import React from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextBlock from '@component/common/block/text-block';
import ProgressBar from '@design-system/progress-bar';
import { ETheme } from '@datatype/type';

interface IProps {
  current: number;
  total: number;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: ${size.MARGIN_1};
`;

const ProgressRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  gap: ${size.MARGIN_1};
`;

const ProgressBarContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

const CounterContainer = styled.div`
  flex: 0 0 auto;
  white-space: nowrap;
`;

const LABEL_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: true },
  box: { alignX: 'center' },
} as const;

const COUNTER_DESIGN = {
  text: { size: 'small', color: color.GRAY_1, bold: false },
  box: { alignX: 'right' },
} as const;

const GUIDE_DESIGN = {
  text: { size: 'medium', color: color.GRAY_1, bold: false },
  box: { alignX: 'center' },
} as const;

const PlayingIndicator: React.FC<IProps> = ({ current, total }) => {
  const clampedCurrent = Math.min(current, total);
  const ratio = total === 0 ? 0 : clampedCurrent / total;
  return (
    <Wrapper>
      <TextBlock text={'이야기를 듣고 있어요'} design={LABEL_DESIGN} />
      <ProgressRow>
        <ProgressBarContainer>
          <ProgressBar ratio={ratio} theme={ETheme.BROWN} width='100%' />
        </ProgressBarContainer>
        <CounterContainer>
          <TextBlock text={`${clampedCurrent} / ${total}`} design={COUNTER_DESIGN} />
        </CounterContainer>
      </ProgressRow>
      <TextBlock text={'잘 듣고 답변을 떠올려보세요'} design={GUIDE_DESIGN} />
    </Wrapper>
  );
};

export default PlayingIndicator;
